export const isValidEmailAddress = (emailAddress) => {
  {
    const validEmailRegex =
      /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (
      emailAddress.length > 0 &&
      emailAddress.length < 100 &&
      validEmailRegex.test(emailAddress)
    );
  }
};
